import React from "react";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import "./public-layout.css";

function PublicLayout(props) {
  return (
    <div className="public-layout-shell">
      <header className="public-hero">
        <div className="public-hero-top">
          <p className="public-hero-overline">Institut expert visage</p>
        </div>

        <h1>Soins du visage <br/>à Aix-en-Provence</h1>

        <p className="public-hero-tags">
          Corneotherapie <span>&bull;</span> Facialisme <span>&bull;</span> Technologies
        </p>
      </header>

      <main className="public-layout-main">
        {props.view && <props.view />}
      </main>

      <footer className="public-footer">
        <section className="public-footer-col public-footer-center">
          <img src="/asset/image/logo.webp" alt="Inoutskin" className="public-footer-logo" />
          <p>Institut expert visage</p>
          <div className="public-footer-socials">
            <a
              href="https://www.facebook.com/share/1AdHraXP3e/"
              target="_blank"
              rel="noreferrer"
              aria-label="Facebook"
            >
              <FacebookIcon fontSize="inherit" />
            </a>
            <a
              href="https://www.instagram.com/inout_skin?igsh=MTFmZTZzdWt5ZGFheg=="
              target="_blank"
              rel="noreferrer"
              aria-label="Instagram"
            >
              <InstagramIcon fontSize="inherit" />
            </a>
          </div>
        </section>
      </footer>
    </div>
  );
}

export default PublicLayout;
